import { render, staticRenderFns } from "./project-info-scroll.vue?vue&type=template&id=5127345c&scoped=true"
import script from "./project-info-scroll.vue?vue&type=script&lang=js"
export * from "./project-info-scroll.vue?vue&type=script&lang=js"
import style0 from "./project-info-scroll.vue?vue&type=style&index=0&id=5127345c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127345c",
  null
  
)

export default component.exports